import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class FaviconService {
  setFavicon(iconUrl: string): void {
    const head = document.getElementsByTagName('head')[0];
    const existingIcon = document.getElementById('dynamic-favicon');

    if (existingIcon) {
      head.removeChild(existingIcon);
    }

    // Stores without their own icon return an empty favicon_file. Appending a link for that
    // would sit last in <head> and win over the static Labrador icon in index.html, leaving the
    // tab pointing at /undefined. Fall back to the static icon instead.
    if (!iconUrl) {
      return;
    }

    const newIcon = document.createElement('link');
    newIcon.id = 'dynamic-favicon';
    newIcon.rel = 'icon';
    newIcon.href = iconUrl;
    head.appendChild(newIcon);
  }
}
